import { MIME_TYPES } from './mimeData.js'

/**
 * Content-type detection shared with the node server: mimeData.js is
 * generated from the same `mime` package Nephele uses (see
 * generate-mime-data.mjs), replacing the old ~30-entry hardcoded table —
 * both servers answer identically for every known extension
 * (browserdav-transport-robustness).
 */
export class MimeTypeDetector {
    constructor() {
        this.mimeTypes = MIME_TYPES
    }

    detectMimeType(filename) {
        const extension = filename.split('.').pop().toLowerCase()
        return this.mimeTypes[extension] || 'application/octet-stream'
    }
}